const Audi = [
    {
        ID: "audi_1",
        name: "R8",
        brand: "Audi",
        price: 4,
        engine: "V10 5.2L",
        max: 323,
        version: "7 S-Tronic",
        type: "Coupe",
        avatar: "https://i.ibb.co/jfFBJjZ/r8-2.webp",
        link: "/brands/audi/r8",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "audi_2",
        name: "R8 Decennium",
        brand: "Audi",
        price: 5.9,
        engine: "V10 5.2L",
        max: 331,
        version: "7 S-Tronic",
        type: "Coupe",
        avatar: "https://i.ibb.co/2vnCNDn/decennium.webp",
        link: "/brands/audi/r8-decennium",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "audi_3",
        name: "R8 Green Hell",
        brand: "Audi",
        price: 6.4,
        engine: "V10 5.2L",
        max: 331,
        version: "7 S-Tronic",
        type: "Coupe",
        avatar: "https://i.ibb.co/BnLSbpf/audi-r8-green-hell-edition-front-removebg-preview.webp",
        link: "/brands/audi/r8-green-hell",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default Audi;
